import TechnologicalFeaturesFinep from ".";
import { TechnologicalFeaturesFinepProvider } from "../../../Contexts/TechnologicalFeaturesFinepContext";

const TabTechnologicalFeaturesFinepContextChildren = () => {
    return (
        <TechnologicalFeaturesFinepProvider>
            <TechnologicalFeaturesFinep />
        </TechnologicalFeaturesFinepProvider>
    );
}

export default TabTechnologicalFeaturesFinepContextChildren;